import { Directive, ElementRef, HostListener, Renderer2 } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { SlValueAccessor } from './sl-value-accessor';

@Directive({
  selector: 'sl-checkbox, sl-switch',
  providers: [{ provide: NG_VALUE_ACCESSOR, useExisting: SlCheckboxValueAccessorDirective, multi: true }]
})
export class SlCheckboxValueAccessorDirective extends SlValueAccessor<HTMLInputElement> implements ControlValueAccessor {
  constructor(element: ElementRef<HTMLInputElement>, renderer: Renderer2) {
    super(element, renderer, 'value');
  }

  writeValue(value: string) {
    this.renderer.setProperty(this.element.nativeElement, 'checked', value);
  }
  
  @HostListener('checkedChange', ['$event'])
  handleValueChange(event: CustomEvent) {
    let value = this.element.nativeElement.checked;
    event.stopPropagation();
    this.onChange(value);
  }
  
}